<div class="font-bold mb-3" i18n>
  Group Identifiers (Level 1 and/or Level 2) empower you to associate eSIMs with a particular group of brands or enterprise entities such as
  Mobile Virtual Network Operators. For example, mobile devices with read the pre-determined value at initial boot-up and apply a device OS
  image and/or associated device application for an MNO brand or an MVNO. There are two levels of Group Identifiers and the use of one
  (i.e., GID1) or both (i.e., GID1 & GID2) is optional. The content of the Group Identifiers is up to your discretion.
</div>
<div class="font-bold mb-3" i18n>Do you want to use the Group Identifiers?</div>
<div class="ml-6 mb-3">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="updateGroupIdentifiers()"
          name="groupIdentifiers.useGroupIdentifiers"
          inputId="groupIdentifiers.useGroupIdentifiers#1"
          value="1"
          [(ngModel)]="profileValues.groupIdentifiers.useGroupIdentifiers"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="groupIdentifiers.useGroupIdentifiers#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="updateGroupIdentifiers()"
          name="groupIdentifiers.useGroupIdentifiers"
          inputId="groupIdentifiers.useGroupIdentifiers#0"
          value="0"
          [(ngModel)]="profileValues.groupIdentifiers.useGroupIdentifiers"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="groupIdentifiers.useGroupIdentifiers#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
<div *ngIf="+profileValues.groupIdentifiers.useGroupIdentifiers === 1" class="font-bold mb-3" i18n>Please enter GID1 and/or GID2.</div>
<div *ngIf="+profileValues.groupIdentifiers.useGroupIdentifiers === 1" class="ml-6 mr-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <div class="font-bold mr-3" i18n>GID1:</div>
      </td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="16"
          [(ngModel)]="profileValues.groupIdentifiers.gid1"
          (input)="updateGroupIdentifiers()"
        />
      </td>
      <td><div class="ml-3" i18n>(8 HEX bytes)</div></td>
    </tr>
    <tr>
      <td>
        <div class="font-bold mr-3" i18n>GID2:</div>
      </td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="16"
          [(ngModel)]="profileValues.groupIdentifiers.gid2"
          (input)="updateGroupIdentifiers()"
        />
      </td>
      <td><div class="ml-3" i18n>(8 HEX bytes)</div></td>
    </tr>
  </table>
  <div [ngStyle]="{ visibility: errorFound ? 'visible' : 'hidden' }" class="pt-3 mb-3" style="color: var(--rs-red)">
    <i class="mr-2 pi pi-times-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>
</div>
